import s from './Notification.module.scss';
import IconFilledInfo from "@/shared/ui/Icons/IconFilledInfo";
import Button from "@/shared/ui/Button";
import cx from 'classnames';

type NotificationProps = {
  text?: string,
  withIcon?: boolean,
  buttonText?: string,
  buttonOnClick?: () => void,
  hint?: string,
  className?: string,
  innerClassName?: string,
}

const Notification = (props: NotificationProps) => {
  const {
    hint ,
    text,
    withIcon = true,
    buttonText,
    buttonOnClick,
    className,
    innerClassName,
  } = props;

  return (
    <div className={cx(s.root, className)}>
      <div className={cx(s.notification, innerClassName)}>
        {withIcon ? (
          <IconFilledInfo className="opacity-60 flex-shrink-0" />
        ) : null}

        {text ? (
          <span className="flex-grow">
            {text}
          </span>
        ) : null}

        {buttonText ? <Button className="flex-shrink-0" colorSchema="secondary" onClick={buttonOnClick} text={buttonText} /> : null}
      </div>
      {hint ? <div className={s.hint}>{hint}</div> : null}
    </div>
  );
}

export default Notification;
